import React from 'react';

import { dataHooks } from '../../constants';
import { FieldSetProps } from '../../FieldSet.types';
import InfoIcon from '../../../InfoIcon';

import { st, classes } from './InfoContentIcon.st.css';

type Props = Pick<
  FieldSetProps,
  'infoContent' | 'infoTooltipProps' | 'required'
>;

const InfoContentIcon = ({
  infoContent,
  infoTooltipProps,
  required,
}: Props) => {
  return infoContent ? (
    <InfoIcon
      dataHook={dataHooks.infoIcon}
      className={st(classes.root, {
        required,
      })}
      content={infoContent}
      tooltipProps={infoTooltipProps}
      size="small"
    />
  ) : null;
};

export default InfoContentIcon;
